import { Spinner } from "../../components/Spinner";
import {
  useGetUserData,
  useGetUserStatistics,
} from "../../helpers/queries/user/useGetUserData";
import { Link } from "react-router-dom";
import VulnerabilityTable from "./Dashboard/VulnerabilityTable";
import { SeverityChart } from "./Dashboard/SeverityChart";
import RecentScans from "./Dashboard/RecentScans";
import { useEffect, useState } from "react";
import NameCard from "../../components/NameCard";
import { Button } from "../../components/ui/button";
import { FiArrowUpRight } from "react-icons/fi";
import ScanAssetModal from "../../components/modals/ScanAssetModal";
// import { useGetAllTargets } from "../../helpers/queries/targets/useGetTargets";
import AddTargetModal from "./Targets/modals/AddTargetModal";
import { useGetAssetGroups } from "../../helpers/queries/scans/useGetInventory";

const Dashboard = () => {
  const { isLoading, isSuccess, isError, data } = useGetUserStatistics();
  const { data: user } = useGetUserData();
  const role = user?.user?.role;
  // const { data: targets } = useGetAllTargets();
  const { data: assetGroupList } = useGetAssetGroups(0);

  const [severityChartData, setSeverityChartData] = useState([]);
  const [topVulnerability, setTopVulnerability] = useState([]);

  useEffect(() => {
    if (data) {
      const chartData = [
        {
          level: "Critical",
          count: data.critical_count ?? 0,
        },
        {
          level: "High",
          count: data.high_count ?? 0,
        },
        {
          level: "Medium",
          count: data.medium_count ?? 0,
        },
        {
          level: "Low",
          count: data.low_count ?? 0,
        },
      ];

      setSeverityChartData(chartData);
      setTopVulnerability(data.top_vulnerabilities);
    }
  }, [data]);

  return (
    <>
      <div className="w-full">
        <div className=" w-full lg:block flex justify-between items-center py-6 lg:px-10 md:px-5 px-4 bg-white border-b ">
          <div className="w-full flex md:flex-row flex-col md:justify-between md:items-center gap-2 mb-1">
            <NameCard />
            {role &&
              role !== "Viewer" &&
              (assetGroupList && assetGroupList?.data?.length === 0 ? (
                <AddTargetModal
                  is_asset_group={true}
                  triggerLabel="Create asset group"
                />
              ) : (
                <ScanAssetModal />
              ))}
          </div>
        </div>

        {isLoading && !isSuccess && (
          <div className="h-[55vh] w-full flex items-center justify-center">
            <Spinner />
          </div>
        )}

        {isError && !isLoading && (
          <div className="h-[45vh] w-full flex justify-center flex-col items-center">
            <p className="font-semibold text-xl text-center">
              There was an error getting the data
            </p>
            <p className="text-center">{data?.message ?? ""}</p>
          </div>
        )}

        {!isLoading && isSuccess && data && (
          <div className="lg:p-10 md:p-5 p-4 bg-white h-[100%]">
            <div className="flex xl:flex-row flex-col justify-between gap-4 mb-4">
              <div className="xl:w-[70%]">
                <div className="grid lg:grid-cols-3 md:grid-cols-3 gap-4 md:space-y-0 space-y-4 items-center mb-4">
                  <div className="border-[3px] border-secondary200 rounded-lg p-[1px]">
                    <div className="w-full border-2 border-dashed border-[#71788450] rounded-lg p-3">
                      <div className="mb-3">
                        <p className="text-sm font-medium text-gray-400">
                          Total Assets
                        </p>
                      </div>
                      <div className="flex justify-between items-center gap-2">
                        <div className="flex flex-col gap-4">
                          <p className="text-[28px] text-black font-semibold leading-none">
                            {data?.total_assets ?? 0}
                          </p>
                        </div>
                        <Link to={"/dashboard/inventory"}>
                          <Button variant="outline" className="p-2">
                            View all <FiArrowUpRight size={18} />
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="border-[3px] border-secondary200 rounded-lg p-[1px]">
                    <div className="w-full border-2 border-dashed border-[#71788450] rounded-lg p-3">
                      <div className="mb-3">
                        <p className="text-sm font-medium text-gray-400">
                          Total Scans
                        </p>
                      </div>
                      <div className="flex justify-between items-center gap-2">
                        <div className="flex flex-col gap-4">
                          <p className="text-[28px] text-black font-semibold leading-none">
                            {data?.scans ?? 0}
                          </p>
                        </div>
                        <Link to={"/dashboard/scan-history"}>
                          <Button variant="outline" className="p-2">
                            View all <FiArrowUpRight size={18} />
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>

                  <div className="border-[3px] border-secondary200 rounded-lg p-[1px]">
                    <div className="w-full border-2 border-dashed border-[#71788450] rounded-lg p-3">
                      <div className="mb-3">
                        <p className="text-sm font-medium text-gray-400">
                          Total Vulnerabilities
                        </p>
                      </div>
                      <div className="flex justify-between items-center gap-2">
                        <div className="flex flex-col gap-4">
                          <p className="text-[28px] text-black font-semibold leading-none">
                            {data?.vulns ?? 0}
                          </p>
                        </div>
                        <Link to={"/dashboard/insights"}>
                          <Button variant="outline" className="p-2">
                            View all <FiArrowUpRight size={18} />
                          </Button>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <VulnerabilityTable topVulnerability={topVulnerability} />
              </div>
              <div className="xl:w-[30%]">
                <SeverityChart severityChartData={severityChartData} />
              </div>
            </div>

            <div className="mb-2">
              <RecentScans />
            </div>
          </div>
        )}

        {data?.data?.length === 0 && !isLoading && isSuccess && (
          <div className=" h-[45vh] w-full flex justify-center flex-col items-center text-center">
            <p className=" font-semibold text-xl">There are no results</p>
          </div>
        )}
      </div>
    </>
  );
};

export default Dashboard;
